// src/WallpaperStats.js
import React, { useState, useEffect } from "react";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import app from "./firebase";

export default function WallpaperStats() {
  const [wallpapers, setWallpapers] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: "downloads", direction: "desc" });

  useEffect(() => {
    const fetchWallpapers = async () => {
      const db = getFirestore(app);
      const querySnapshot = await getDocs(collection(db, "wallpapers"));
      const data = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const filtered = data
        .filter((w) => typeof w.downloads === "number" || typeof w.likes === "number")
        .sort((a, b) => (b.downloads || 0) - (a.downloads || 0))
        .slice(0, 100);

      setWallpapers(filtered);
    };

    fetchWallpapers();
  }, []);

  const handleSort = (key) => {
    let direction = "desc";
    if (sortConfig.key === key && sortConfig.direction === "desc") {
      direction = "asc";
    }
    setSortConfig({ key, direction });

    const sorted = [...wallpapers].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });
    setWallpapers(sorted);
  };

  // ✅ Sabiranje ukupno lajkova i preuzimanja
  const totalLikes = wallpapers.reduce((sum, w) => sum + (w.likes || 0), 0);
  const totalDownloads = wallpapers.reduce((sum, w) => sum + (w.downloads || 0), 0);

  return (
    <div style={{ padding: "20px" }}>
      <h2>📊 Top 100 Wallpapers by Likes & Downloads</h2>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          textAlign: "left",
          marginTop: "20px",
          fontSize: "15px",
        }}
      >
        <thead>
          <tr style={{ borderBottom: "2px solid #ccc" }}>
            <th style={{ padding: "8px 6px", width: "40px" }}>#</th>
            <th style={{ padding: "8px 6px", width: "70px" }}>Thumb</th>
            <th style={{ padding: "8px 6px", width: "180px" }}>Name</th>
            <th
              style={{ padding: "8px 6px", cursor: "pointer", width: "80px" }}
              onClick={() => handleSort("likes")}
            >
              Likes {sortConfig.key === "likes" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
            </th>
            <th
              style={{ padding: "8px 6px", cursor: "pointer", width: "100px" }}
              onClick={() => handleSort("downloads")}
            >
              Downloads {sortConfig.key === "downloads" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
            </th>
            <th style={{ padding: "8px 6px", width: "80px" }}>%</th>
          </tr>
        </thead>

        <tbody>
          {wallpapers.map((w, index) => {
            const percent =
              totalDownloads > 0 ? ((w.downloads || 0) / totalDownloads * 100).toFixed(1) : 0;

            return (
              <tr key={w.id} style={{ borderBottom: "1px solid #eee" }}>
                <td style={{ padding: "6px 6px" }}>{index + 1}</td>
                <td style={{ padding: "6px 6px" }}>
                  {w.thumbUrl ? (
                    <img
                      src={w.thumbUrl}
                      alt={w.name}
                      style={{
                        width: "50px",
                        height: "auto",
                        borderRadius: "4px",
                        display: "block",
                      }}
                    />
                  ) : (
                    "—"
                  )}
                </td>
                <td
                  style={{
                    padding: "6px 6px",
                    maxWidth: "180px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {w.name || "N/A"}
                </td>
                <td style={{ padding: "6px 6px" }}>{w.likes ?? 0}</td>
                <td style={{ padding: "6px 6px" }}>{w.downloads ?? 0}</td>
                <td style={{ padding: "6px 6px" }}>{percent}%</td>
              </tr>
            );
          })}

          {/* ✅ Zbir na dnu */}
          <tr style={{ borderTop: "3px solid #000", background: "#f5f5f5", fontWeight: "bold" }}>
            <td style={{ padding: "8px" }} colSpan="3">
              TOTAL
            </td>
            <td style={{ padding: "8px" }}>{totalLikes}</td>
            <td style={{ padding: "8px" }}>{totalDownloads}</td>
            <td style={{ padding: "8px" }}>100%</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
